import { TweenMax, TimelineMax } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class SnowflakeChallenges {
  private _patternStagger: TweenMax;
  private _panels: TweenMax;
  private _iconPolicyholder: TweenMax;
  private _iconCost: TweenMax;
  // private _text1: TweenMax;
  // private _text2: TweenMax;
  // private _text3: TweenMax;
  // private _text4: TweenMax;

  private _timelinePattern = new TimelineMax({repeat: -1, repeatDelay: 0.5});
  private _timelineIcons = new TimelineMax();
  // private _timelineText1 = new TimelineMax();
  // private _timelineText2 = new TimelineMax();

  init ( ): void {
    this._patternStagger = TweenMax.to('#square-grid rect', { scale: 1.5, yoyo: true, repeat: 1, duration: 0.1, stagger: { each: 0.2, grid: [42, 72], from: 'random' } });
    this._panels = TweenMax.from('.challenges-content article ul li', { opacity: '0', top: 60, duration: 1, stagger: { amount: 0.5 } });
    this._iconPolicyholder = TweenMax.fromTo('.challenges-content .icon-policyholder path', { drawSVG: '0' }, { drawSVG: '100%', duration: 1, stagger: { from: 'random', amount: 0.5 } });
    this._iconCost = TweenMax.fromTo('.challenges-content .icon-cost path, .challenges-content .icon-cost line, .challenges-content .icon-cost circle', { drawSVG: '0' }, { drawSVG: '100%', duration: 1, stagger: { from: 'random', amount: 0.5 } });
    // this._text1 = TweenMax.from('.challenges-content .gsap-text-1', { opacity:0, y: -30, duration: 1 });
    // this._text2 = TweenMax.from('.challenges-content .gsap-text-2', { opacity:0, y: -30, duration: 1 });
    // this._text3 = TweenMax.from('.challenges-content .gsap-text-3', { opacity:0, y: -30, duration: 1 });
    // this._text4 = TweenMax.from('.challenges-content .gsap-text-4', { opacity:0, y: -30, duration: 1 });

    this._timelinePattern.add( this._patternStagger );
    // this._timelineText1.add( this._text1 );
    // this._timelineText1.add( this._text2, 0.5 );
    this._timelineIcons.add( this._panels );
    this._timelineIcons.add( this._iconPolicyholder, 0.5 );
    this._timelineIcons.add( this._iconCost, 1 );
    // this._timelineText2.add( this._text3 );
    // this._timelineText2.add( this._text4, 0.5 );

    ScrollTrigger.create({
      animation: this._timelinePattern,
      trigger: '.challenges-wrapper',
      start: 'top center',
      end: 'center top',
      toggleActions: 'play pause resume reset'
    });

    // ScrollTrigger.create({
    //   animation: this._timelineText1,
    //   trigger: '.challenges-content header',
    //   start: 'top center'
    // });

    ScrollTrigger.create({
      animation: this._timelineIcons,
      trigger: '.challenges-content article',
      start: 'top center'
    });

    // ScrollTrigger.create({
    //   animation: this._timelineText2,
    //   trigger: '.challenges-content footer',
    //   start: 'top center'
    // });
  }

  constructor ( ) { }
}
